import { Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { Calculator } from '@/components/Calculator';
import { CadrComparisonTable } from '@/components/CadrComparisonTable';
import { PopularGuides } from '@/components/PopularGuides';
import { FAQ } from '@/components/FAQ';
import { Footer } from '@/components/Footer';
import { StickyMobileCTA } from '@/components/StickyMobileCTA';

const Index = () => (
  <div className="min-h-screen bg-background">
    <Header />
    <main className="container mx-auto px-4">
      <section id="hero" className="pt-6">
        <Hero />
      </section>
      <section id="calculator" className="py-6 max-w-2xl mx-auto scroll-mt-16">
        <Calculator syncUrl />
      </section>
      <section id="cadr-table" className="py-12 section-divider">
        <CadrComparisonTable />
      </section>
      <PopularGuides />
      <section id="faq" className="py-16 section-divider">
        <FAQ />
      </section>
    </main>
    <Footer />
    <StickyMobileCTA />
  </div>
);

export default Index;
